exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ivu-select-selection[data-v-2a498980]{border-radius:8px!important;height:40px;display:flex;align-items:center}.ivu-select-input[data-v-2a498980]{text-align:center}.ivu-select-arrow[data-v-2a498980]{color:#2d8cf0;transition:transform .3s}.ivu-select-opened .ivu-select-arrow[data-v-2a498980]{transform:rotate(180deg)}.nodata[data-v-2a498980]{display:flex;justify-content:center;align-items:center;height:300px;border:1px solid #ddd;font-size:20px;font-weight:700;color:red;text-align:center;width:100%;height:500px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a498980","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--5!./src/component/dic-manage/dic-manage.vue
// module id = 4
// module chunks = 0